import { Card, ThemeProvider } from "@mui/material";
import { keepPreviousData } from "@tanstack/react-query";
import LoadingScreen from "components/loading/LoadingScreen";
import ModalCallExportHistories from "components/modal-call-export-histories/ModalCallExportHistories";
import Table from "components/table/Table";
import { ALL_OPTION } from "constant";
import { useModalState } from "hooks/useModalState";
import { usePagination } from "hooks/usePagination";
import moment from "moment";
import ReportOutboundCallByExtFilter from "pages/reports/report-outbound-call-by-ext/components/ReportOutboundCallByExtFilter";
import { useMemo, useState } from "react";
import {
  useExportReportOutboundCallByExt,
  useGetReportOutboundCallByExt,
} from "service/query/report.query";
import muiTheme from "theme/muiTheme";

const ReportOutboundCallByExt = () => {
  const [filter, setFilter] = useState(null);
  const { data: reportOutboundCallByExt, isFetching } =
    useGetReportOutboundCallByExt(
      {
        ...filter,
      },
      {
        enabled: !!filter,
        placeholderData: keepPreviousData,
      }
    );
  // phân trang client
  const {
    page,
    pageSize,
    handleChangePage,
    handleChangePageSize,
    clientData,
    clientTotal,
  } = usePagination(reportOutboundCallByExt);

  const handleSubmit = (values) => {
    const from = moment(values.dateRange[0]).toISOString();
    const to = moment(values.dateRange[1]).toISOString();

    // Ban đầu ALL nên tất cả giá trị value = null
    // Check chỉ gửi điều kiện nhỏ nhất lên
    let valueCityCode = null;
    let valueDistrict = null;
    let valueSubOrg = null;

    if (
      values.cityCode !== ALL_OPTION.value &&
      values.district === ALL_OPTION.value &&
      values.subOrg === ALL_OPTION.value
    ) {
      valueCityCode = values.cityCode;
    }
    if (
      values.cityCode !== ALL_OPTION.value &&
      values.district !== ALL_OPTION.value &&
      values.subOrg === ALL_OPTION.value
    ) {
      valueDistrict = values.district;
    }

    if (
      values.cityCode !== ALL_OPTION.value &&
      values.district !== ALL_OPTION.value &&
      values.subOrg !== ALL_OPTION.value
    ) {
      valueSubOrg = values.subOrg;
    }

    setFilter({
      cityCode: valueCityCode,
      district: valueDistrict,
      subOrg: valueSubOrg,
      typePbx: values.typePbx === ALL_OPTION.value ? null : values.typePbx,
      extensions: values.extensions || null,
      from,
      to,
    });

    handleChangePage(1);
  };

  const modalExportHistories = useModalState();

  const columns = useMemo(
    () => [
      {
        id: "cityCode",
        name: "Mã BĐT",
      },
      {
        id: "cityName",
        name: "Tên BĐT",
      },
      {
        id: "provinceCode",
        name: "Mã BC",
      },
      {
        id: "provinceName",
        name: "Tên Bưu cục",
      },

      {
        id: "extensionName",
        name: "Số máy lẻ",
      },
      {
        id: "totalCall",
        name: "Tổng cuộc gọi ra",
      },
      {
        id: "haveLadingCod",
        name: "Tổng bưu gửi gắn Log cuộc gọi",
      },

      {
        id: "totalAnsweredCall",
        name: "Số cuộc trả lời",
      },
      {
        id: "totalLadingCodeAndAnsweredCall",
        name: "Số bưu gửi trả lời",
      },
      {
        id: "totalNoAnsweredCall",
        name: "Số cuộc không trả lời",
      },
      {
        id: "totalBusyCall",
        name: "Số cuộc bận",
      },
      {
        id: "totalFailedCall",
        name: "Số cuộc không liên lạc được",
      },
      {
        id: "responseRate",
        name: "Tỷ lệ trả lời",
      },
    ],
    []
  );

  // const { refetch: handleExport, isFetching: isFetchingExport } =
  //   useExportDetailOutboundCall(filter, null, modalExportHistories.openModal);
  const { refetch: handleExport, isFetching: isFetchingExport } =
    useExportReportOutboundCallByExt(
      {
        ...filter,
        isExport: true,
      },
      { enabled: false }
    );

  return (
    <ThemeProvider theme={muiTheme}>
      <Card sx={{ mb: 2 }}>
        <ReportOutboundCallByExtFilter
          onSubmit={handleSubmit}
          onExport={handleExport}
          isDisabledExport={!filter}
        />
      </Card>

      <Card>
        <Table
          columns={columns}
          data={clientData}
          toolbar={{
            title: "Tổng hợp cuộc gọi ra theo máy lẻ",
            // onViewHistories: modalExportHistories.openModal,
          }}
          pagination={{
            page,
            pageSize,
            totalItems: clientTotal,
            onPageChange: handleChangePage,
            onPageSizeChange: handleChangePageSize,
          }}
        />
      </Card>

      <LoadingScreen loading={isFetching || isFetchingExport} />

      {modalExportHistories.open && (
        <ModalCallExportHistories
          open={modalExportHistories.open}
          onClose={modalExportHistories.closeModal}
          type="detailOutboundCall"
        />
      )}
    </ThemeProvider>
  );
};

export default ReportOutboundCallByExt;
